import { render, staticRenderFns } from "./MpHintBox.vue?vue&type=template&id=e66d7280&"
import script from "./MpHintBox.vue?vue&type=script&lang=js&"
export * from "./MpHintBox.vue?vue&type=script&lang=js&"
import style0 from "./MpHintBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports